import Order, { OrderSellerData } from './model/Order';
import React, { useEffect, useState } from 'react';
import { useOrderQueries } from './hooks/useOrderQueries';
import { useTranslation } from 'react-i18next';

type OrderSellerInformationProps = {
  order: Order;
};

export const OrderSellerInformation = ({ order }: OrderSellerInformationProps) => {
  const { t } = useTranslation();
  const [orderSellerData, setOrderSellerData] = useState<OrderSellerData>();
  const { getOrderSellerData } = useOrderQueries();

  useEffect(() => {
    getOrderSellerData(order.orderId, order.suborderId).then((it) => setOrderSellerData(it));
  }, [order, getOrderSellerData]);

  return (
    <div>
      {orderSellerData && orderSellerData.sellerName && (
        <span data-testid="orderSellerData">
          {t('form.fields.order_number.order_selector.order_sold_and_shipped_by')}{' '}
          <strong data-testid="orderSellerData.sellerName">{orderSellerData.sellerName}</strong>
        </span>
      )}
    </div>
  );
};
